(function ($) {
  'use strict';

  // Class name for mobile sub nav li
  let liParentClassName = 'menu-parenttitle';
  let menuLevelExpandedClass = 'menu-level-expanded';
  window.menuPartHideClass = 'hidden-mm';
  window.mobileBreakpoint = 1024;
  let numResize = 0;
  let resize = '';

  // show hide mobile menu on screen resize
  $(window).resize(function () {
    if (window.outerWidth >= window.mobileBreakpoint) {
      $('.hamburger--menu-container-icon__open').addClass('is-active');
      $('.hamburger--menu-container-icon__close').removeClass('is-active');
      $('.region-mobile-menu,.region-mobile-menu div.menu-dropdown-0 ul').addClass(window.menuPartHideClass);
      $('.region-mobile-menu div.menu-dropdown-0 ul').removeClass(menuLevelExpandedClass);
      $('.menu_link_content').attr('aria-hidden', 'true');
    }
    else {
      $('.region-mobile-menu').show();
    }

    if (numResize <= 1) {
      resize = setTimeout(function () {
        $(window).resize();
        numResize++;
      }, 200);
    }
    else {
      clearTimeout(resize);
      numResize = 0;
    }
  });

  // mobile menu click functionality
  $('.hamburger--menu-container-icon').click(function () {
    $('.hamburger--menu-container-icon').toggleClass('is-active');

    if ($('.hamburger--menu-container-icon__close').hasClass('is-active')) {
      $('.region-mobile-menu').removeClass(window.menuPartHideClass);
    }
    else {
      $('.region-mobile-menu,.region-mobile-menu div.menu-dropdown-0 ul.menu-level-1').addClass(window.menuPartHideClass);
      $('.region-mobile-menu div.menu-dropdown-0 ul').removeClass(menuLevelExpandedClass);
    }
  });

  // showing nav level 2
  $('.region-mobile-menu ul.menu-level-0>li.menu-item--expanded>a').click(function (e) {
    e.preventDefault();
    let nextUl = $(this).parent('.menu-item--expanded').find('ul.menu-level-1');
    let menuContainer = $(this).parent('.menu-item--expanded').find('.menu_link_content');
    if (!nextUl.hasClass(menuLevelExpandedClass)) {
      menuContainer.attr('aria-hidden', 'false');
      nextUl.removeClass(window.menuPartHideClass);
      nextUl.addClass(menuLevelExpandedClass);
      nextUl.find(`li.${liParentClassName}`).first().remove();
      nextUl.prepend(`<li class='${liParentClassName}'><div class='parent-title-inner'><div class='icon-chevron-left mm-back'></div>${$(this)[0].outerHTML}</div></li>`);
    }
  });

  // hiding nav level 2
  $('.region-mobile-menu ul.menu-level-1').on('click', `li.${liParentClassName} div.mm-back`, function (event) {
    $(this).parents('ul.menu-level-1').addClass(window.menuPartHideClass);
    $(this).parents('.menu_link_content').attr('aria-hidden', 'true');
    setTimeout(() => {
      $(this).parents('ul.menu-level-1').removeClass(menuLevelExpandedClass);
    }, 250);
  });
})(jQuery);
